
import React from 'react';
import { format } from 'date-fns';
import { pl, enUS } from 'date-fns/locale';
import { useLanguage } from '@/hooks/useLanguage';
import { Badge } from '@/components/ui/badge';
import { ShieldAlert } from 'lucide-react';
import { VulnerabilityItem } from '@/types/dashboard';

interface VulnerabilityItemProps {
  vulnerability: VulnerabilityItem;
}

export function VulnerabilityListItem({ vulnerability }: VulnerabilityItemProps) {
  const { language, t } = useLanguage();
  
  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd MMM yyyy', {
        locale: language === 'pl' ? pl : enUS,
      });
    } catch (error) {
      return dateString;
    }
  };

  // Get the translated description based on language
  const getLocalizedDescription = () => {
    if (language === 'pl' && vulnerability.description_pl) {
      return vulnerability.description_pl;
    }
    return vulnerability.description || t('common.no_description');
  };

  return (
    <div className="space-y-1">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <ShieldAlert className="h-4 w-4 mr-1 text-destructive" />
          <h3 className="font-medium">{vulnerability.id || "CVE-unknown"}</h3>
        </div>
        <Badge variant="destructive" className="ml-2 text-xs">
          {vulnerability.score.toFixed(1)}
        </Badge>
      </div>
      <div className="text-xs text-muted-foreground flex justify-between">
        <span className="line-clamp-1">{getLocalizedDescription()}</span>
      </div>
      <div className="text-xs text-muted-foreground">
        <span>{formatDate(vulnerability.publishedDate)}</span>
      </div>
    </div>
  );
}
